import { useRef, useEffect, useState } from "react";

interface TruncatedDescriptionProps {
    description: string;
}

const TruncatedDescription = ({ description, onClick }: any) => {
    const descRef = useRef<HTMLParagraphElement | null>(null);
    const [isTruncated, setIsTruncated] = useState(false);
    const [visibleChars, setVisibleChars] = useState<number>(0);
    const [showFull, setShowFull] = useState(false);

    useEffect(() => {
        const el = descRef.current;
        if (!el) return;

        const measureTruncation = () => {
            el.innerText = description;

            if (el.scrollHeight <= el.clientHeight) {
                setIsTruncated(false);
                setVisibleChars(description.length);
                return;
            }

            let low = 0;
            let high = description.length;
            let best = 0;

            while (low <= high) {
                const mid = Math.floor((low + high) / 2);
                el.innerText = description.slice(0, mid);

                if (el.scrollHeight <= el.clientHeight) {
                    best = mid;
                    low = mid + 1;
                } else {
                    high = mid - 1;
                }
            }

            setIsTruncated(true);
            setVisibleChars(best);
        };

        requestAnimationFrame(measureTruncation);
    }, [description]);

    const extraCharsToShow = Math.floor(visibleChars-17);
    const remainingText = description.slice(visibleChars, visibleChars + extraCharsToShow);

    const isShowReadMore = (description?.length > (visibleChars + remainingText?.length)) ? true : false

    return (
        <div className="descriptionContainer cardDescription2">
            <p className=" descriptionContainer-line-clamp" ref={descRef}>
                {description.slice(0, visibleChars)}
            </p>

            {isTruncated && remainingText && (
                <p>
                    {remainingText}
                    {isShowReadMore &&
                        <button className="theme-text-color" onClick={onClick}>
                            &nbsp;...
                        </button>
                    }
                </p>
            )}
        </div>
    );
};

export default TruncatedDescription;
